import React, { useState, useEffect, useCallback } from 'react';
import { getLocalStorageItem } from '@utils/storageUtils';

export type ThemeType = 'light' | 'dark';

type ThemeStateType = {
    theme: ThemeType;
    setTheme: (theme: ThemeType) => void;
};

export const initialThemeState: ThemeStateType = {
    theme: 'dark',
    setTheme: (theme: ThemeType) => null,
};

const ThemeContext = React.createContext<ThemeStateType>(initialThemeState);

export const useTheme = () => {
    return React.useContext(ThemeContext);
};

const DARK_THEME_QUERY = '(prefers-color-scheme: dark)';

const MyThemeProvider = ({ children }) => {
    const savedTheme = getLocalStorageItem('Replan.theme');
    const [theme, setTheme] = useState<ThemeType>(
        savedTheme ? savedTheme : window.matchMedia(DARK_THEME_QUERY).matches ? 'dark' : 'light'
    );

    useEffect(() => {
        const savedTheme = getLocalStorageItem('Replan.theme');
        const mediaQueryList = window.matchMedia(DARK_THEME_QUERY);

        const handleMatch = () => {
            const theme = mediaQueryList.matches ? 'dark' : 'light';
            setTheme(theme);
            localStorage.removeItem('Replan.theme');
        };

        mediaQueryList.addEventListener('change', handleMatch);

        setTheme(
            savedTheme ? savedTheme : window.matchMedia(DARK_THEME_QUERY).matches ? 'dark' : 'light'
        );

        return () => mediaQueryList.removeEventListener('change', handleMatch);
    }, []);

    //TODO page is fully reloaded instead of setTheme, because of necessity to completely reload map sources/layers otherwise
    // useEffect(() => {
    //   localStorage.setItem("Replan.theme", theme);
    // }, [theme]);

    const updateTheme = useCallback((theme: ThemeType) => {
        setTheme(theme);
        localStorage.setItem('Replan.theme', theme);
        // window.location.reload();
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setTheme: updateTheme }}>
            {/*<div className={`theme--${theme}`}>*/}
            {children}
            {/*</div>*/}
        </ThemeContext.Provider>
    );
};

export default MyThemeProvider;
